import React, { useCallback, useRef, useState } from 'react';
import Modal from 'src/Utils/CssModules/modal.module.css';
import Button from '../Button/Button';
import './SmallDialog.css'
import useOutsideClick from 'src/Utils/Hooks/UseOutSideClick/UseOutSideClick';
import { useTranslation } from 'react-i18next';
export interface ISmallDialogParams {
    title: string
    children: React.ReactNode,
    onSubmit: () => void,
    onClose: () => void,
    submitButtonText: string;
}
const SmallDialog: React.FC<ISmallDialogParams> = ({ title, children, onSubmit, onClose, submitButtonText}) => {
    // 'flex' rather than 'block': the inline style wins over Modal.centered,
    // which needs the overlay to be a flex container to centre the dialog.
    const [display, setdisplay] = useState('flex');
    const wrapperRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();
    useOutsideClick(wrapperRef, () => { close()})
    const close = useCallback(() => {
        setdisplay('none');
        onClose();
    }, [onClose]);
    const submit = useCallback(() => {
        setdisplay('none');
        onSubmit();
    }, [onSubmit]);
    return (
        <div className='row'>
            <div id="myModal" className={`${Modal.modal} ${Modal.centered}`} style={{ display: display, zIndex: 1001 }}>
                <div className={`${Modal.content} smallcontent`} ref={wrapperRef}>
                    {/* Figma sets the dialog title at the shared modal header scale
                        (20/600), not the 24px this used to hard-code, and pads it
                        symmetrically so the centred title actually reads centred
                        against Modal.header's 26px left padding. */}
                    <div className={`${Modal.header} pb-2`} style={{ textAlign: 'center', paddingLeft: '30px', paddingRight: '30px' }}>
                        {t(title)}
                    </div>

                    <div className={Modal.body} style={{padding:'1px 30px 0px 30px'}}>
                        {children}
                    </div>

                    {/* Cancel and the confirm action sit centred as a pair, the way
                        Figma draws them — the old col-6/col-auto split pushed them
                        off-centre in the narrow small-dialog width. */}
                    <div className={Modal.footer} style={{padding:'20px 30px'}}>
                        <div className="d-flex justify-content-center gap-3">
                            <Button
                                variant='secondary'
                                testId='close'
                                onClick={() => { close() }}
                                text={t('Cancel')}
                                width='141px'
                            />
                            <Button
                                testId='ok'
                                onClick={() => { submit() }}
                                text={submitButtonText}
                                width='141px'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SmallDialog;